module.exports = __webpack_public_path__ + "img/flaggstikk1.86425df1.jpg";